// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9fed99a5","488":"0b6f7d30","732":"e9f9bb42"}[chunkId] + ".chunk.js";
};